"use client";

import Link from "next/link";

import { ChevronLeftIcon } from "@saas/shared/icon";

export interface ILoyaltyRouteHeaderProps {
  label: string;
  backUrl: string;
  testid?: string;
}

export const LoyaltyRouteHeader = ({
  label,
  backUrl,
  testid,
}: ILoyaltyRouteHeaderProps) => {
  return (
    <div
      className={
        "border-b-neutral-N100 top-0 z-10 flex w-full items-center gap-4 border-b-[1px] bg-white px-5 py-4"
      }
    >
      <div className={"mx-auto flex w-full items-center gap-4"}>
        <Link href={backUrl} data-testid={testid + "__link"}>
          <ChevronLeftIcon className={"text-neutral-N600 h-6 w-6"} />
        </Link>

        <div>
          <span
            className={"body-b2 text-he font-semibold"}
            data-testid={testid + "__text__header"}
          >
            {label}
          </span>
        </div>
      </div>
    </div>
  );
};
